<template>
    <div v-if="simulation">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-lg-12">
                    <simulation ref="simulation"
                        :simulation="simulation"
                        :simulations="simulations"
                        :registration="registration"
                        :allow-comment-edit="true"
                        @change="reloadSimulation">
                    </simulation>

                    <tabs class="tabs"
                        tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper"
                        tabContentClasses="card shadow"
                        v-if="registration.degree.simulation_role_2 && hasSecondGrid"
                    >
                        <tab-pane id="grid1">
                            <span slot="title">
                                {{ registration.degree.simulation_role_1_name[registration.degree.lang] }}
                            </span>
                            <simulations
                                :learner="learner"
                                :simulations="lastSimulations"
                                :registration="registration"
                                :competencies="competencies"
                                :position1-competencies="position1Competencies"
                                :position2-competencies="position2Competencies"
                                :rating-options="ratingOptions"
                                :num="1"
                            ></simulations>
                        </tab-pane>

                        <tab-pane id="grid2">
                            <span slot="title">
                                {{ registration.degree.simulation_role_2_name[registration.degree.lang] }}
                            </span>
                            <simulations
                                :learner="learner"
                                :simulations="lastSimulations"
                                :competencies="competencies"
                                :position1-competencies="position1Competencies"
                                :position2-competencies="position2Competencies"
v                                :registration="registration"
                                :rating-options="ratingOptions"
                                :num="2"
                            ></simulations>
                        </tab-pane>
                    </tabs>

                    <simulations
                        :learner="learner"
                        :simulations="lastSimulations"
                        :competencies="competencies"
                        :position1-competencies="position1Competencies"
                        :position2-competencies="position2Competencies"
                        :registration="registration"
                        :rating-options="ratingOptions"
                        :num="1"
                        v-else
                    ></simulations>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Simulation from './learner/Simulation';
    import Simulations from './learner/PrivateReviewSimulations';

    export default {

        components: {
            Simulation, Simulations,
        },

        data() {
            return {
                learner: {},
                registration: null,
                simulation: null,
                simulations: null,
                competencies: null,
                position1Competencies: null,
                position2Competencies: null,
                ratingOptions: null,
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/registrations/'+to.params.registrationId+'/simulations/'+to.params.simulationId+'/learners/'+to.params.learnerId)
            .then(resp => {
                next(vm => {
                    vm.simulation = resp.data.data
                    vm.registration = resp.data.included.registration
                    vm.simulations = resp.data.included.simulations
                    vm.competencies = resp.data.included.competencies
                    vm.position1Competencies = resp.data.included.position1_competencies
                    vm.position2Competencies = resp.data.included.position2_competencies
                    vm.learner = resp.data.included.learner
                    vm.ratingOptions = resp.data.included.rating_options
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        },

        watch: {
            // Transversal reviews navigation causes change of simulation ID without reloading the component.
            // So we need to refresh the component manually.
            '$route.params.simulationId': function (id) {
                axios.get('/astral/api/front/dashboard/registrations/'+this.registration.id+'/simulations/'+this.$route.params.simulationId+'/learners/'+this.$route.params.learnerId)
                .then(resp => {
                    this.simulation = resp.data.data
                    this.registration = resp.data.included.registration
                    this.simulations = resp.data.included.simulations
                    this.competencies = resp.data.included.competencies
                    this.position1Competencies = resp.data.included.position1_competencies
                    this.position2Competencies = resp.data.included.position2_competencies
                    this.learner = resp.data.included.learner
                    this.ratingOptions = resp.data.included.rating_options
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.learner.name,
                        route: '/astral/ui/dashboard/learners/' + this.$route.params.learnerId
                    },
                    {
                        name: this.registration.degree.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/learners/' + this.$route.params.learnerId
                    },
                    {
                        name: this.simulation.name,
                    },
                ]
            },

            hasSecondGrid() {
                for (var index in this.lastSimulations) {
                    if (this.lastSimulations[index].grid2_id) {
                        return true
                    }
                }
                return false
            },

            lastSimulations() {
                // Find the first and last index.
                let firstIndex = 0
                let lastIndex = 0
                for (let index in this.simulations) {
                    let simulation = this.simulations[index]
                    if (simulation.id == this.simulation.id) {
                        break
                    } else if (simulation.assessment && simulation.private) {
                        firstIndex = index
                        lastIndex = index
                    } else {
                        lastIndex = index
                    }
                }

                // Filter the simulations.
                return this.simulations.filter((simulation, index) => index >= firstIndex && index <= lastIndex && !simulation.assessment)
            },
        },

        methods: {

            reloadSimulation() {
                axios.get('/astral/api/front/dashboard/registrations/'+this.$route.params.registrationId+'/simulations/'+this.$route.params.simulationId+'/learners/'+this.$route.params.learnerId)
                .then(resp => {
                    this.simulation = resp.data.data
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            }
        }
    }
</script>

<style scoped>

    .tabs >>> .nav-pills {
        padding-top: 0;
        padding-bottom: 1.5rem;
    }

</style>
